import { createSlice } from "@reduxjs/toolkit";
import { User } from "../../types/user";
import { authApi } from "../services/auth.api";

export const UserSlice = createSlice({
  name: "user",
  initialState: {} as User,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints.login.matchFulfilled,
      (state, action) => {
        return action.payload.user;
      }
    );
  },
});
